export default {
    props: {
        value: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
        confirm(args) {
            this.onConfirm();


            this.$emit('input', false);
            this.$emit('confirm', args);
        },

        onConfirm() {
            //the component can redeclare any custom action in here
        },

        close(args) {
            this.onClose();

            this.$emit('input', false);
            this.$emit('close', args);
        },

        onClose() {
            //the component can redeclare any custom action in here
        },
    },
}
